
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12.93 2.65C12.73 2.45 12.42 2.45 12.22 2.65L10.21 4.66H14.93L12.93 2.65ZM12.23 21.35C12.43 21.55 12.74 21.55 12.94 21.35L14.92 19.37H10.26L12.23 21.35ZM10.98 17.73C11.58 17.73 11.99 17.13 11.77 16.57L8.04002 7.03C7.86002 6.57 7.41002 6.27 6.92002 6.27C6.43002 6.27 5.98002 6.57 5.80002 7.03L2.06002 16.56C1.84002 17.12 2.25002 17.72 2.85002 17.72C3.20002 17.72 3.52002 17.5 3.65002 17.17L4.36002 15.27H9.47002L10.18 17.17C10.31 17.51 10.63 17.73 10.98 17.73ZM4.97002 13.64L6.91002 8.46L8.85002 13.64H4.97002ZM21.05 16.14H15.72L21.44 7.85C21.9 7.19 21.42 6.28 20.62 6.28H14.14C13.7 6.28 13.35 6.64 13.35 7.08V7.09C13.35 7.53 13.71 7.89 14.14 7.89H19.23L13.5 16.17C13.04 16.83 13.52 17.74 14.32 17.74H21.04C21.48 17.74 21.83 17.38 21.83 16.95C21.85 16.5 21.49 16.14 21.05 16.14Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-sort-by-alpha`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSortByAlpha

    ```js
    <b-new-b-icon-sort-by-alpha />
    ```
</docs>


